import { QBItemSelection } from '@/components/query-builder/models';
import { UrlSuggestion } from '@/components/query-builder/text-value';
import { StorePage } from '@/features/editor/context/use-device-navigation';
import { rmTrailingSlash } from '@/utils/url';
import {
  isNotCheckoutPage,
  PAGE_PATH_CAPTION,
  PAGE_URL_CAPTION,
  toFullUrl,
  toPathWithParams,
} from '@/features/editor/widgets/shared/modals/placement-url-utils';

const URL_ROW_CAPTIONS = [PAGE_URL_CAPTION, PAGE_PATH_CAPTION];
const MAX_SUGGESTIONS = 100;

const isUrlRow = (row: QBItemSelection) =>
  URL_ROW_CAPTIONS.includes(row?.qbProps?.caption);

const isPagePathRow = (row: QBItemSelection) =>
  row?.qbProps?.caption === PAGE_PATH_CAPTION;

const shouldKeepParams = (row: QBItemSelection) =>
  !isPagePathRow(row) && !!row.includeQueryParams;

const removeParams = (url: string) => {
  const urlWithoutParams = url.split(`?`)[0];
  return urlWithoutParams === `/`
    ? urlWithoutParams
    : rmTrailingSlash(urlWithoutParams);
};

const toSuggestionUrl = (page: StorePage, row: QBItemSelection) => {
  const url = isPagePathRow(row)
    ? toPathWithParams(page.url)
    : toFullUrl(page.url);
  return shouldKeepParams(row) ? url : removeParams(url);
};

const doesPageMatchSearch = (page: StorePage, url: string, search: string) =>
  url.toLowerCase().includes(search) ||
  page.caption.toLowerCase().includes(search);

export const getPlacementUrlSuggestions = (
  storePages: StorePage[],
  search: string,
  row: QBItemSelection,
): UrlSuggestion[] => {
  if (!isUrlRow(row)) {
    return [];
  }
  const lowerSearch = (search || ``).trim().toLowerCase();
  const urls = new Set<string>();
  (storePages || []).filter(isNotCheckoutPage).some((page) => {
    const url = toSuggestionUrl(page, row);
    if (doesPageMatchSearch(page, url, lowerSearch)) {
      urls.add(url);
    }
    return urls.size === MAX_SUGGESTIONS;
  });
  return Array.from(urls).map((url) => ({ label: url, url }));
};
